import { useQuery } from "@tanstack/react-query";
import { SystemInputStates } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
import i18n from "i18n";
const PROBLEMATIC_STATES = /* @__PURE__ */ new Set(["FAILED", "FAILING", "SETUP"]);
const useInputStateSummary = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["inputs", "state-summary"],
    queryFn: () => defaultOnError(
      SystemInputStates.summary({ requestShouldExtendSession: false }),
      i18n.t("use_input_state_summary_notifications.load_failed", { ns: "inputs" }),
      i18n.t("use_input_state_summary_notifications.load_failed_title", { ns: "inputs" })
    ),
    refetchInterval: 5e3,
    retry: false
  });
  const hasProblematicInputs = data ? Object.values(data).some((states) => states.some((s) => PROBLEMATIC_STATES.has(s))) : false;
  return { hasProblematicInputs, isLoading };
};
export default useInputStateSummary;
